import { topicWall } from "@/mocks/homeData";

export default function TopicWall() {
  return (
    <section id="topics" className="scroll-mt-24 bg-background-100/70">
      <div className="mx-auto max-w-6xl px-4 py-16 md:px-6 md:py-20">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">Topic Wall / 话题墙</p>
        <div className="mt-2 flex flex-wrap items-end justify-between gap-4">
          <h2 className="font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
            塌房方向，按题材分开蹲
          </h2>
          <p className="max-w-md text-sm leading-6 text-foreground-600">
            不按平台热点堆，而是按「翻车类型」归堆，点进任意话题都能捞到对应人物档案。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3">
          {topicWall.map((group) => (
            <div key={group.group} className="rounded-xl border border-background-200 bg-background-50 p-6">
              <div className="flex items-center gap-2">
                <span className="grid h-7 w-7 place-items-center rounded-md bg-secondary-100 text-secondary-900">
                  <i className="ri-price-tag-3-line text-sm leading-none" />
                </span>
                <h3 className="font-heading text-lg font-bold text-foreground-950">{group.group}</h3>
              </div>
              <p className="mt-2 text-sm leading-6 text-foreground-600">{group.desc}</p>

              <div className="mt-5 flex flex-wrap gap-2">
                {group.topics.map((t) => (
                  <a
                    key={t.name}
                    href="#featured"
                    className="group inline-flex h-9 items-center gap-1.5 whitespace-nowrap rounded-full border border-background-200 bg-background-100 px-3.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:bg-primary-100 hover:text-primary-800 cursor-pointer"
                  >
                    <span className={`h-1.5 w-1.5 rounded-full ${t.hot ? "bg-primary-500" : "bg-background-300 group-hover:bg-primary-400"}`} />
                    {t.name}
                    <span className="text-xs text-foreground-500">· {t.count}</span>
                  </a>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}